/* Nimble — carousel, sticky add-to-cart, header state, custom checkout */
(function () {
  'use strict';

  /* ---------- Review carousel ---------- */
  if (!customElements.get('nm-carousel')) {
    customElements.define(
      'nm-carousel',
      class NmCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.nm-carousel__track');
          this.prev = this.querySelector('[data-dir="-1"]');
          this.next = this.querySelector('[data-dir="1"]');
          this.bar = this.querySelector('.nm-carousel__progress');
          if (!this.track) return;
          this.querySelectorAll('.nm-carousel__btn').forEach((btn) =>
            btn.addEventListener('click', () => this.go(Number(btn.dataset.dir)))
          );
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          window.addEventListener('resize', () => this.update());
          this.update();
        }
        go(dir) {
          const slide = this.track.querySelector('.nm-carousel__slide');
          if (!slide) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: dir * (slide.offsetWidth + gap), behavior: 'smooth' });
        }
        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const x = this.track.scrollLeft;
          if (this.prev) this.prev.disabled = x <= 4;
          if (this.next) this.next.disabled = x >= max - 4;
          if (this.bar) {
            const visible = this.track.clientWidth / this.track.scrollWidth;
            const pct = max <= 0 ? 100 : (visible + (1 - visible) * (x / max)) * 100;
            this.bar.style.setProperty('--nm-progress', pct + '%');
          }
        }
      }
    );
  }

  /* ---------- Sticky add to cart ---------- */
  if (!customElements.get('nm-sticky-atc')) {
    customElements.define(
      'nm-sticky-atc',
      class NmStickyAtc extends HTMLElement {
        connectedCallback() {
          this.mainBtn = document.querySelector('product-info .product-form__submit, .product-form__submit[name="add"]');
          this.btn = this.querySelector('[data-nm-sticky-btn]');
          this.price = this.querySelector('[data-nm-sticky-price]');
          if (!this.mainBtn || !this.btn) return;

          this.btn.addEventListener('click', () => {
            this.mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (!this.mainBtn.disabled) this.mainBtn.click();
          });

          const io = new IntersectionObserver(
            ([entry]) => {
              const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', show);
              this.setAttribute('aria-hidden', String(!show));
              this.btn.tabIndex = show ? 0 : -1;
            },
            { threshold: 0 }
          );
          io.observe(this.mainBtn);

          // Keep price + availability in sync with the selected variant
          const sync = () => {
            const mainPrice = document.querySelector('product-info .price .price-item--sale, product-info .price .price-item--regular');
            const container = document.querySelector('product-info .price');
            if (container && this.price) {
              const sale = container.classList.contains('price--on-sale')
                ? container.querySelector('.price__sale .price-item--sale')
                : container.querySelector('.price__regular .price-item--regular');
              const el = sale || mainPrice;
              if (el) this.price.textContent = el.textContent.trim();
            }
            this.btn.disabled = this.mainBtn.disabled;
            const label = this.mainBtn.querySelector('span');
            if (this.mainBtn.disabled && label) this.btn.textContent = label.textContent.trim();
            else if (!this.mainBtn.disabled) this.btn.textContent = this.btn.dataset.label || this.btn.textContent;
          };
          this.btn.dataset.label = this.btn.textContent.trim();
          const priceRoot = document.querySelector('product-info');
          if (priceRoot) new MutationObserver(sync).observe(priceRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'class'] });
        }
      }
    );
  }

  /* ---------- Header shadow on scroll ---------- */
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      document.documentElement.classList.toggle('nm-scrolled', window.scrollY > 24);
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

})();

/* ---------- "Read more" for long text blocks (keeps sections short) ---------- */
(function () {
  var SEL = '.image-with-text__text.rte, .rich-text__text.rte';
  function clamp(el) {
    if (el.dataset.nmClamp) return;
    el.dataset.nmClamp = '1';
    var limit = window.matchMedia('(max-width: 749px)').matches ? 220 : 260;
    if (el.scrollHeight <= limit + 80) return;
    el.classList.add('nm-clamp');
    el.style.setProperty('--nm-clamp-h', limit + 'px');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nm-readmore link';
    btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.textContent = open ? 'Show less' : 'Read more';
      btn.setAttribute('aria-expanded', String(open));
      if (!open) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    el.insertAdjacentElement('afterend', btn);
  }
  function run(scope) { (scope || document).querySelectorAll(SEL).forEach(clamp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
